import React , {useState , useContext}from 'react'
import TopBaner from '../TopBaner/topBaner';
import SideBar from '../SideBar/sideBar';
import Footer from '../Footer/Footer';
import emailjs from 'emailjs-com';
import Context from '../../context/context';
import CircularProgress from '@mui/material/CircularProgress';

function Comments() {
  const {state, dispatch} = useContext(Context);
  const [comment,setComment] = useState('');
  const [isLoading, setIsLoading] = useState(false);

  const handleSend = () => {
    setIsLoading(true);
    const templateParams = {
      from_name : state.email , 
      comment: comment
    };

    emailjs
      .send('AskOrbits', 'template_c5pvdz3', templateParams, 'Awn2UEURtJzV-xy2K')
      .then((response) => {
        setIsLoading(false);
        alert('המשוב נשלח בהצלחה');
      })
      .catch((error) => {
        alert('שגיאה בשליחת המשוב:', error);
      });
  };
  
  const handleChange = (event) => {
    setComment(event.target.value); 
  };

  return (
    <div>
      <TopBaner></TopBaner>
      <SideBar></SideBar>
      {isLoading && (
                            <div style={{ position: 'relative' }}>
                                <div
                                    style={{
                                        position: 'fixed',
                                        top: '50%',
                                        left: '50%',
                                        transform: 'translate(-50%, -50%)',
                                        zIndex: 9999,
                                        padding: '20px',
                                        borderRadius: '8px',
                                    }}
                                >
                                    <CircularProgress sx={{ color: '#3422F2' }} size={200} />
                                </div>
                            </div>
                        )}

      <div className='card commentsDiv'>
        <div style={{ 'textAlign': 'center'}}>
                <img src="pycBlueIogo.png" alt="logo-pych" style={{height :'100px'}}/>
        </div>
        <h3>... כתוב לנו </h3>
        <p>? חושבים שיש לכם הצעות ייעול </p>
        <textarea
          className='invitationInput'
          placeholder="הערות *"
          rows={4}
          style={{ direction: 'rtl' , height : '100px' }}
          value={comment}
          onChange={handleChange}
        />
        <button
        className='optionsBtn commentsBtn'
        style={{marginLeft : '-20px'}}
        variant="contained"
        onClick={handleSend}
        sx={{ mt: 1, mr: 1 }}
        >
          שלח
        </button>
      </div>
      <Footer></Footer>
    </div>
  )
}

export default Comments